let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fQbJ3")).then(() => parcelRequire('5NHpB'));